export const convertHrsToMs = (hours: number) => hours * 3600 * 1000;
